<template>
    <v-app>
        <v-form ref="form" v-show="!isSubmitted" v-model="valid" @submit.prevent="submit">
            <v-container fluid>

			<div v-show="step === 1">

                <h2 class="pb-1 font-weight-regular">Please complete the following information:</h2>
                <p><strong class="asterix">* </strong>indicates required field.</p>

				<v-radio-group v-model="form.materialRetrieval" class="pt-4">
					<template>
						<div>
							<strong>Choose Pickup or Delivery</strong><strong class="asterix"> *</strong>

						</div>
					</template>
					<v-radio value=0 class='pt-4'>
						<template v-slot:label>
							<div>Pick Up at a Columbus Metropolitan Library Location</div>
						</template>
					</v-radio>
					<v-radio value=1>
						<template v-slot:label>
							<div>Deliver to School</div>
						</template>
					</v-radio>
				</v-radio-group>

                <div v-show="form.materialRetrieval == 0">
                    <v-col class="d-flex pl-0 pb-0 col-12 col-sm-8 col-md-5 col-lg-5">
					    <template>
						    <div><strong>Select a Pick-up Location</strong><strong class="asterix"> *</strong></div>
					    </template>
				    </v-col>
                    <v-col class="d-flex pl-0 col-12 col-sm-8 col-md-5 col-lg-5">
					    <v-select v-model="form.pickUpLocation" :items="branchLocations" label="- Select -" outlined :rules="inputDisabled ? [] : [rules.required]" :disabled="inputDisabled"></v-select>
                    </v-col>
                    <v-col class="d-flex pl-0 pb-0 col-12 col-sm-8 col-md-5 col-lg-5">
                        <template>
                            <div><strong>Choose Pick-up Date</strong><strong class="asterix"> *</strong></div>
                        </template>
                    </v-col>
                    <v-col class="d-flex pl-0 col-12 col-sm-8 col-md-5 col-lg-5">
					    <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="date" transition="scale-transition" offset-y min-width="290px">
						    <template v-slot:activator="{ on, attrs }">
							    <v-text-field v-model="form.date" label="Choose date" readonly v-bind="attrs" v-on="on" outlined :rules="inputDisabled ? [] : [rules.required]"  :disabled="inputDisabled || temporarilyClosed"></v-text-field>
						    </template>
						    <v-date-picker v-model="form.date" no-title scrollable :allowed-dates="getAllowedDates" :min="nowDate" :max="maxDate">
                                <v-spacer></v-spacer>
							    <v-btn text color="primary" @click="menu = false">
								    Cancel
							    </v-btn>
							    <v-btn text color="primary" @click="$refs.menu.save(date)">
								    OK
							    </v-btn>
						    </v-date-picker>
				        </v-menu>
				    </v-col>
                </div>

				<div v-show="form.materialRetrieval == '1'">
                    <v-col class="d-flex pl-0 pb-0 col-12 col-sm-8 col-md-5 col-lg-5">
					    <template>
						    <div><strong>School Delivery Location</strong><strong class="asterix"> *</strong></div>
					    </template>
				    </v-col>
                    <v-col class="d-flex pl-0 pb-0 col-12 col-sm-8 col-md-5 col-lg-5">
                        <template>
                            <div class="smalltext">Note: Only available at schools included in the drop-down list.</div>
                        </template>
                    </v-col>
                    <v-col class="d-flex pl-0 col-12 col-sm-8 col-md-5 col-lg-5">
					    <v-select v-model="form.deliverSchool" :items="deliverSchools" label="- Select -" outlined :rules="!inputDisabled ? [] : [rules.required]"  :disabled="!inputDisabled"></v-select>
                    </v-col>
                    <v-col class="d-flex pl-0 pb-0 col-12 col-sm-8 col-md-5 col-lg-5">
                        <template>
                            <div><strong>Delivery Month</strong><strong class="asterix"> *</strong></div>
                        </template>
                    </v-col>
                    <v-col class="d-flex pl-0 col-12 col-sm-8 col-md-5 col-lg-5">
					    <v-select v-model="form.deliverMonth" :items="filterDeliverMonth" label="- Select -" outlined :rules="!inputDisabled ? [] : [rules.required]"  :disabled="!inputDisabled"></v-select>
                    </v-col>
                </div>


				<v-btn @click="checkValid(true)" class="tc-button submit-btn">Continue</v-btn>
				<v-btn @click="cancel()" class="ml-4 tc-button">
				    <v-icon class="pr-1">mdi-close-thick</v-icon>Cancel
				</v-btn>

			</div>

			<div v-show="step==2">

				<v-col class="grey lighten-1 rounded pl-0 col-12 col-sm-10 col-md-12 col-lg-12">
					<div class="ml-3">
						<h2 class="pb-2 pl-6 font-weight-regular">Contact Information</h2>
                        <v-col class="d-flex pl-6 pb-1 col-12 col-sm-10 col-md-10 col-lg-10">
							<template>
								<div><strong>Name:</strong> {{ form.firstname }} {{ form.lastname }}</div>
							</template>
						</v-col>
						<v-col class="d-flex pl-6 pb-0 col-12 col-sm-10 col-md-10 col-lg-10">
							<template>
								<div><strong>Phone Number</strong><strong class="asterix"> *</strong></div>
							</template>
						</v-col>
						<v-col class="d-flex pl-6 pb-0 col-12 col-sm-10 col-md-10 col-lg-10">
							<v-text-field v-model="form.phoneNumber" outlined background-color="white" :value="form.phoneNumber" :rules="[rules.required, rules.phone]" type="tel"></v-text-field>
						</v-col>
						<v-col class="d-flex pl-6 pb-0 col-12 col-sm-10 col-md-10 col-lg-10">
							<template>
								<div><strong>Mobile Phone Number</strong></div>
							</template>
						</v-col>
						<v-col class="d-flex pl-6 pb-0 col-12 col-sm-10 col-md-10 col-lg-10">
							<v-text-field v-model="form.mobileNumber" outlined background-color="white" :value="form.mobileNumber" :rules="[rules.phone]"></v-text-field>
						</v-col>
						<v-col class="d-flex pl-6 pb-0 col-12 col-sm-10 col-md-10 col-lg-10">
							<template>
								<strong>Email Address</strong><strong class="asterix"> *</strong>
							</template>
						</v-col>
						<v-col class="d-flex pl-6 pb-0 col-12 col-sm-10 col-md-10 col-lg-10">
							<v-text-field v-model="form.email" outlined background-color="white" :value="form.email" :rules="[rules.required, rules.email]"></v-text-field>
						</v-col>
					</div>
				</v-col>

				<v-col class="d-flex pl-0 col-12 col-sm-10 col-md-12 col-lg-12">
					<div class="pl-0 flex">

						<v-col v-if="form.deliverSchool" class="d-flex pl-0 pb-3 col-12 col-sm-10 col-md-10 col-lg-10">
							<template>
								<div><strong>School:</strong> {{ setSchool }}</div>
							</template>
						</v-col>
                        <div v-else>
                            <v-col class="d-flex pl-0 pb-0 col-12 col-sm-10 col-md-10 col-lg-10">
                                <template>
                                    <div><strong>School</strong><strong class="asterix"> *</strong></div>
                                </template>
                            </v-col>
                            <v-col class="d-flex pl-0 pb-0 col-12 col-sm-10 col-md-10 col-lg-10">
                                <v-text-field v-model="form.school" outlined :value="form.school" :rules="[rules.required]"></v-text-field>
                            </v-col>
                        </div>

						<v-col class="d-flex pl-0 pb-0 col-12 col-sm-10 col-md-10 col-lg-10">
							<template>
								<div><strong>Grade</strong><strong class="asterix"> *</strong></div>
							</template>
						</v-col>
						<v-col class="d-flex pl-0 col-12 col-sm-10 col-md-10 col-lg-10">
							<v-select v-model="form.grade" :items="grade" label="- Select -" outlined :rules="[rules.required]"></v-select>
						</v-col>

						<v-col class="d-flex pl-0 pb-0 col-12 col-sm-10 col-md-10 col-lg-10">
							<template>
								<div><strong>Reading Level</strong><strong class="asterix"> *</strong></div>
							</template>
						</v-col>
						<v-row class="pl-3 col-12 col-sm-10 col-md-10 col-lg-10">
                            <v-col class='pl-0'>
                                <v-checkbox v-model="form.readAloud" label="Read Alouds" value=1 hide-details></v-checkbox>
                                <v-checkbox v-model="form.baby" label="Baby (0-18 months)" value=1 hide-details></v-checkbox>
                                <v-checkbox v-model="form.toddler" label="Toddler (18-36 months)" value=1 hide-details></v-checkbox>
                                <v-checkbox v-model="form.preSchool" label="Preschool (3-4 years)" value=1 hide-details></v-checkbox>
                                <v-checkbox v-model="form.preK" label="Pre-Kindergarten (4-5 years)" value=1 hide-details></v-checkbox>
                                <v-checkbox v-model="form.kinder" label="Kindergarten" value=1 hide-details></v-checkbox>
                                <v-checkbox v-model="form.first" label="1st Grade" value=1 hide-details></v-checkbox>
                                <v-checkbox v-model="form.second" label="2nd Grade" value=1 hide-details></v-checkbox>
                                <v-checkbox v-model="form.third" label="3rd Grade" value=1 hide-details></v-checkbox>
                            </v-col>
                            <v-col class='pl-0'>
                                <v-checkbox v-model="form.fourth" label="4th Grade" value=1 hide-details></v-checkbox>
                                <v-checkbox v-model="form.fifth" label="5th Grade" value=1 hide-details></v-checkbox>
                                <v-checkbox v-model="form.sixth" label="6th Grade" value=1 hide-details></v-checkbox>
                                <v-checkbox v-model="form.seventh" label="7th grade" value=1 hide-details></v-checkbox>
                                <v-checkbox v-model="form.eighth" label="8th Grade" value=1 hide-details></v-checkbox>
                                <v-checkbox v-model="form.ninth" label="9th Grade" value=1 hide-details></v-checkbox>
                                <v-checkbox v-model="form.tenth" label="10th Grade" value=1 hide-details></v-checkbox>
                                <v-checkbox v-model="form.eleventh" label="11th Grade" value=1 hide-details></v-checkbox>
                                <v-checkbox v-model="form.twelfth" label="12th Grade" value=1 hide-details></v-checkbox>
                            </v-col>
						</v-row>

                        <v-col class="d-flex pl-0 pb-0 col-12 col-sm-10 col-md-10 col-lg-10">
							<template>
								<div><strong>Requested Topics</strong><strong class="asterix"> *</strong></div>
							</template>
						</v-col>
						<v-col class="d-flex pl-0 pb-0 col-12 col-sm-10 col-md-10 col-lg-10">
							<v-textarea v-model="form.requestedTopics" outlined label="Requested Topics" :value="form.requestedTopics" :rules="[rules.required, rules.topicsLength]"></v-textarea>
						</v-col>

                        <v-col class="d-flex pl-0 pb-0 col-12 col-sm-10 col-md-10 col-lg-10">
							<template>
								<div><strong>Number of Items Requested</strong><strong class="asterix"> *</strong></div>
							</template>
						</v-col>
                        <v-row>
                            <v-col>
                                <p>Print/Audio: <strong class="asterix">{{ printAudioTotal }}</strong></p>
                            </v-col>
                            <v-col>
                                <p>DVD: <strong class="asterix">{{ totalDvd }}</strong></p>
                            </v-col>
                            <v-col>
                                <p>Total: <strong class="asterix">{{ totalItems }}</strong></p>
                            </v-col>
                        </v-row>
						<v-row>
                            <v-col class="pa-1">
                                <div class="flex grey lighten-1 rounded">
                                    <div class="pa-1 pt-2">
                                        <strong>Nonfiction</strong>
                                    </div>
                                    <div class="pa-1">
                                        <v-text-field v-model="form.nonFiction" outlined single-line padding=1 background-color="white" label="nonFiction" placeholder=0 :value="form.nonFiction" min=0 max=30 type="number"></v-text-field>
                                    </div>
                                </div>
                            </v-col>
                            <v-col class="pa-1">
                                <div class="flex grey lighten-1 rounded">
                                    <div class="pa-1">
                                        <strong>Fiction</strong>
                                    </div>
                                    <div class="pa-1">
                                        <v-text-field v-model="form.fiction" outlined single-line padding=1 background-color="white" label="fiction" placeholder=0 :value="form.fiction" min=0 max=30 type="number"></v-text-field>
                                    </div>
                                </div>
                            </v-col>
                            <v-col class="pa-1">
                                <div class="flex grey lighten-1 rounded">
                                    <div class="pa-1">
                                        <strong>Picture Book</strong>
                                    </div>
                                    <div class="pa-1">
                                        <v-text-field v-model="form.pictureBook" outlined single-line padding=1 background-color="white" label="pictureBook" placeholder=0 :value="form.pictureBook" min=0 max=30 type="number"></v-text-field>
                                    </div>
                                </div>
                            </v-col>
                            <v-col class="pa-1">
                                <div class="flex grey lighten-1 rounded">
                                    <div class="pa-1">
                                        <strong>Audio</strong>
                                    </div>
                                    <div class="pa-1">
                                        <v-text-field v-model="form.audio" outlined single-line padding=1 background-color="white" label="audio" placeholder=0 :value="form.audio" min=0 max=30 type="number"></v-text-field>
                                    </div>
                                </div>
                            </v-col>
                            <v-col class="pa-1">
                                <div class="flex grey lighten-1 rounded">
                                    <div class="pa-1">
                                        <strong>DVD</strong>
                                    </div>
                                    <div class="pa-1">
                                        <v-text-field v-model="form.dvd" outlined single-line padding=1 background-color="white" label="dvd" placeholder=0 :value="form.dvd" min=0 max=5 type="number"></v-text-field>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                        <v-alert dense outlined :value=alertTriggered type="error">Items are required. Maximum 30 print/audio; 5 DVDs.</v-alert>
					</div>
				</v-col>

				<v-btn type="submit" :disabled="isSubmitting" class="tc-button submit-btn">Submit</v-btn>
				<v-btn @click="cancel()" class="ml-4 tc-button">
					<v-icon class="pr-1">mdi-close-thick</v-icon>Cancel
				</v-btn>

			</div>

		</v-container>
        </v-form>

        <div v-show="isSubmitted">
            <v-container class="text-center mt-15">
                <h2 class="mb-5">Your request has been successfully submitted.</h2>
                <v-btn class="tc-button submit-btn" :href="cmlUrl">Finish</v-btn>
            </v-container>
        </div>
	</v-app>
</template>

<script>
const axios = require("axios");

export default {
    data() {
        return {
            isSubmitting: false,
            isSubmitted: false,
            postUrl: "",
            valid: true,
            menu: false,
            date: "",
            nowDate: new Date().toISOString().slice(0,10),
            modal: false,
            menu2: false,
            form: {
                materialRetrieval: "0",
                pickUpLocation: "",
                deliverSchool: "",
                deliverMonth: "",
                date: "",
                phoneNumber: "",
                mobileNumber: "",
                email: "",
                school: "",
                grade: "",
                readAloud: "",
                baby: "",
                toddler: "",
                preSchool: "",
                preK: "",
                kinder: "",
                first: "",
                second: "",
                third: "",
                fourth: "",
                fifth: "",
                sixth: "",
                seventh: "",
                eighth: "",
                ninth: "",
                tenth: "",
                eleventh: "",
                twelfth: "",
                requestedTopics: "",
                nonFiction: "",
                fiction: "",
                pictureBook: "",
                audio: "",
                dvd: "",
                barcode: "",
                firstname: "",
                lastname: "",
                patronId: ""
            },
            deliverSchools: [],
            branchLocations: [],
            step: 1,
            grade: [],
            datesClosed: [],
            rules: {
                required: value => !!value || "Required.",
                phone: value => {
                    const pattern = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
                    return value ? pattern.test(value) || "Invalid phone number." : true;
                },
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || "Invalid e-mail.";
                },
                topicsLength: value => value.length <= 2000 || "Limited to 2000 characters or less.",
            },
        }
    },
    props: ['dataUrl', 'cmlUrl'],
    computed: {
        printAudioTotal: function() {
            return Number(this.form.nonFiction) + Number(this.form.fiction) + Number(this.form.pictureBook) + Number(this.form.audio) + 0;
        },
        totalDvd: function() {
            return Number(this.form.dvd) + 0;
        },
        totalItems: function() {
            return Number(this.printAudioTotal) + Number(this.form.dvd) + 0;
        },
        alertTriggered: function() {
            if ((this.totalItems <= 0) || (this.totalItems > 35) || this.printAudioTotal > 30 || this.totalDvd > 5) {
                return true;
            } else {
                return false
            }
        },
        filterDeliverMonth: function() {
            if (this.form.deliverSchool) {
                let schoolMonths = this.deliverMonths[this.form.deliverSchool];
                let deliverMonths = [];
                Object.entries(schoolMonths).forEach(data => {
                    deliverMonths.push(data[1])
                });
                return deliverMonths;
            }
        },
        inputDisabled: function() {
            if (this.form.materialRetrieval == '0') {
                return false;
            } else {
                return true;
            }
        },
        temporarilyClosed: function() {
            // No temporarily closed locations right now
            return false;
        },
        maxDate: function() {
            // disable any dates previous to and including today
            let today = new Date();
            today.setMonth(today.getMonth() + 4);
            return today.toISOString().slice(0,10);
        },
        setSchool: function() {
            if (this.form.deliverSchool && this.form.materialRetrieval == 1) {
                let school = this.deliverSchools.filter((s) => {
                    if (s.value == this.form.deliverSchool) {
                        this.form.school = s.text;
                        return s.text;
                    }
                });
                return school[0].text;
            } else {
                this.form.deliverSchool = '';
                this.form.school = '';
                return null;
            }
        }
    },
    methods: {
        async submit() {
            this.isSubmitting = true;

            // Wait until recaptcha has been loaded.
            await this.$recaptchaLoaded();
            // Execute reCAPTCHA with action "login".
            const token = await this.$recaptcha('login');
            this.form.captcha = token;

            if (this.checkValid() && !this.alertTriggered) {
                axios.post(this.postUrl, this.form).then(response => {
                    this.isSubmitted = true;
                    window.scrollTo(0, 0);

                    // alert("Your request has been successfully submitted.");
                    // window.location.replace(this.cmlUrl);
                })
                .catch(error => {
                    alert(error.response.data.error);
                    this.isSubmitting = false;
                });
            } else {
                this.isSubmitting = false;
            }
        },
        checkValid(next = null) {
            if (next) {
                if ((Boolean(this.form.pickUpLocation.trim()) && Boolean(this.form.date.trim())) || (Boolean(this.form.deliverSchool.trim()) && Boolean(this.form.deliverMonth.trim()))) {
                    this.$refs.form.resetValidation();
                    this.step++;
                } else {
                    return this.$refs.form.validate();
                }
            } else {
                return this.$refs.form.validate();
            }
        },
        cancel() {
            window.location.reload();
        },
        getAllowedDates(value) {
            let day = new Date(value).getDay();
            // check against the server provided datesClosed
            if (this.datesClosed.includes(value)) {
                return false;
            } else if (day === 6) {
                // closed on Sundays
                return false;
            } else if (this.form.pickUpLocation == 77 && day === 5 && new Date(value) > new Date(2021, 8, 24)) {
                //Filters out Saturdays (day = 5) at Marion-Franklin (id = 77) after 9/24/2021
                return false;
            } else if (this.form.pickUpLocation == 43 && new Date(value) > new Date(2023, 1, 17) && new Date(value) <= new Date(2023, 2, 18)) {
                //Filters out 2/18/23 - 3/18/23 at Gahanna (id = 43)
                return false;
            } else if (this.form.pickUpLocation == 147 && new Date(value) > new Date(2023, 1, 17) && new Date(value) <= new Date(2023, 2, 18)) {
                //Filters out 2/18/23 - 3/18/23 at Gahanna Curbside (id = 147)
                return false;
            } else {
                return true;
            }
        }
    },
    mounted() {
        // get the form state
        this.dataUrl && axios.get(this.dataUrl).then(response => {
            this.postUrl = response.data.postUrl;

            this.branchLocations = response.data.locations.map(location => ({
                value: location.id.toString(),
                text: location.display_name,
            }));

            let deliverSchools = [];
            Object.entries(response.data.deliverSchools).forEach(data => {
                deliverSchools.push({'value': String(data[1].id), 'text': data[1].school_name})
            });
            this.deliverSchools = deliverSchools;

            let grades = [];
            Object.entries(response.data.grades).forEach(data => {
                grades.push({'value': String(data[0]), 'text': data[1]})
            });
            this.grade = grades;

            this.datesClosed = response.data.datesClosed;

            this.deliverMonths = response.data.deliverSchoolsMonths;
            })
            .catch(error => {
                alert(error.response.data.error);
            });
        this.form.barcode = this.$attrs.patronData.barcode;
        this.form.cellphone = this.$attrs.patronData.cellphone;
        this.form.email = this.$attrs.patronData.email;
        this.form.firstname = this.$attrs.patronData.firstname;
        this.form.lastname = this.$attrs.patronData.lastname;
        this.form.phoneNumber = this.$attrs.patronData.phone;
        this.form.patronId = this.$attrs.patronData.pid;
    }
}
</script>
